<template>
  <tm-skeleton
    type="circle"
    :width="avatarSize"
    :height="avatarSize"
  />
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from '@/composition/vue/compositionApi'
import TmSkeleton from '@/components/shared/skeletons/TmSkeleton.vue'
import type { AvatarSize } from '@/components/shared/types'

export default defineComponent({
  components: {
    TmSkeleton,
  },
  props: {
    size: {
      type: String as PropType<AvatarSize>,
      default: 'medium',
    },
    customSize: {
      type: String,
    },
  },
  setup(props) {
    const avatarSize = computed(() => props.customSize || avatarSize[props.size])

    return {
      avatarSize,
    }
  },
})
</script>
